<template lang="pug">
validation-observer(ref="observer", v-slot="{ validateWithInfo }")
  v-container.the-ms-form
    v-row.px-5
      the-login(v-if="holder.dialog_login", @update="onSignInSuccess", @close="holder.dialog_login = false")
      v-dialog(v-model="holder.dialog", hide-overlay, fullscreen)
        v-card(v-if="holder.selected_type")
          v-toolbar(dark, color='gokleenblue', flat, tile)
            v-btn(icon, dark, @click='closeInfo')
              v-icon mdi-close
            v-toolbar-title 
              | {{ holder.selected_type.name }}
            v-spacer
            v-toolbar-items
              v-btn(dark, text, @click="openTermAndCondition")
                | t&c
              v-btn(v-if="holder.selected_type.files",  dark, text, @click="openFiles")
                | compare
          v-card-text
            v-textarea(
              :value="holder.selected_type.description",
              readonly,
              solo,
              flat,
              no-resize,
              rows="4",
              auto-grow,
              hide-details) 
      v-col.py-0(cols="12")
        .main-title.gokleenblue--text.text-uppercase Quotation Form
      v-col(cols="12")
        v-card.rounded-0(color="gokleenblue")
          v-row.px-2(no-gutters)
            v-col(cols="12", md="4")
              .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }")
                | Service Type
            v-col(cols="12", md="8")
              .py-2.px-1
                v-data-table.elevation-1(
                  :headers="listing.types_headers",
                  :items="listing.types",
                  mobile-breakpoint="300",
                  hide-default-header,
                  hide-default-footer)
                  template(v-slot:item.actions="{ item }")
                    v-checkbox.inline-block(v-model="item.selected", @click="onServiceTypeClick", hide-details)
                    v-icon.inline-block.pb-3.cursor-pointer(@click="showInfo(item)")
                      | mdi-information
      v-col.pt-3(cols="12")
        v-card.rounded-0(color="gokleenblue")
          v-row.px-2(no-gutters)
            v-col(cols="12", md="4")
              .servicetype-title.text-uppercase.white--text.px-2.pt-2(:class="{ 'text-center': breakpoint.lgAndUp }") 
                | SPECIALIZE CLEANING
                .text-capitalize.body-2.font-weight-regular
                  | (Site Visit Date & Time)
            v-col(cols="12", md="8")
              v-row.py-1(no-gutters)
                v-col.pa-1(cols="12", md="6")
                  v-menu(
                    v-model="holder.date_menu",
                    :close-on-content-click="false",
                    :nudge-right="40",
                    transition="scale-transition",
                    offset-y,
                    min-width="290px")
                    template(v-slot:activator="{ on, attrs }")
                      validation-provider(mode="passive", name="date", rules="required")
                        v-text-field(
                          :value="GetFormattedDateOnlyString(item.date)",
                          label="DATE",
                          prepend-inner-icon="mdi-calendar",
                          solo,
                          flat,
                          readonly,
                          hide-details,
                          v-bind="attrs",
                          v-on="on")
                    v-date-picker(
                      v-model="item.date",
                      :allowed-dates="checkAllowedDay",
                      :min="minBookDate",
                      @input="holder.date_menu = false")
                v-col.pa-1(cols="12", md="6")
                  validation-provider(mode="passive", name="time", rules="required")
                    v-select(
                      v-model="item.time",
                      :items="allowed_hour",
                      item-text="text",
                      item-value="value",
                      prepend-inner-icon="mdi-clock-time-four",
                      solo,
                      flat,
                      hide-details,
                      label="TIME")
      v-col.pt-5.pb-0(cols="12")
        v-row(no-gutters)
          v-col(cols="12", :class="{ 'header-info': breakpoint.mdAndUp }")
            .info-text.text-left.gokleenblue--text This information will be used to contact you about your service.
            .info-text.primary--text(v-if="!isLoginCustomer")
              | Already Registered?
              .text-decoration-underline.signin-btn.pl-1(@click="onSignIn") Sign in
      v-col.py-0(cols="12")
        v-card.rounded-0(color="gokleenblue")
          v-row.px-2(no-gutters)
            v-col(cols="12", md="4")
              .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                | Your Contact Info
            v-col(cols="12", md="8")
              v-row.py-1(no-gutters)
                v-col.pa-1(cols="12", md="6")
                  validation-provider(mode="passive", name="first name", rules="required")
                    v-text-field(v-model="item.first_name", label="FIRST NAME", solo, flat, hide-details)
                v-col.pa-1(cols="12", md="6")
                  validation-provider(mode="passive", name="last name", rules="required")
                    v-text-field(v-model="item.last_name", label="LAST NAME", solo, flat, hide-details)
                v-col.pa-1(cols="12", md="6")
                  validation-provider(mode="passive", name="mobile phone", rules="required")
                    v-text-field(v-model="item.contact", label="MOBILE PHONE NO.", solo, flat, hide-details)
                v-col.pa-1(cols="12", md="6")
                  v-text-field(v-model="item.contact_other", label="OTHER PHONE NO.", solo, flat, hide-details)
                v-col.pa-1(cols="12")
                  v-text-field(v-model="item.company_name", label="COMPANY NAME", solo, flat, hide-details)
                v-col.pa-1(cols="12")
                  validation-provider(mode="passive", name="email address", rules="required|email")
                    v-text-field(v-model="item.email", label="EMAIL ADDRESS", solo, flat, hide-details)
      v-col.pt-5(cols="12")
        v-card.rounded-0(color="gokleenblue")
          v-row.px-2(no-gutters)
            v-col(cols="12", md="4")
              .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                | Service Address
            v-col(cols="12", md="8")
              .py-2.px-1
                validation-provider(mode="passive", name="address", rules="required")
                  v-textarea(v-model="item.address", label="ADDRESS", solo, flat, no-resize, rows="3", hide-details)
                span.info-textarea-text.white--text Ex: 577, Jalan Pelita 3, Pelita Commercial Centre, 98000 Miri, Sarawak, Malaysia.
      v-col.pt-5(cols="12")
        v-card.rounded-0(color="gokleenblue")
          v-row.px-2(no-gutters)
            v-col(cols="12", md="4")
              .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }")
                | Remark
            v-col(cols="12", md="8")
              .py-2.px-1
                v-textarea(v-model="item.remark", solo, flat, no-resize, rows="6", hide-details)
                span.info-textarea-text.white--text What needs to inform the cleaning team to be aware?
      v-col(cols="12")
        v-row(no-gutters, justify="center")
          v-col.pa-2(cols="12", md="auto")
            v-btn(dark, x-large, :block="isMobile", rounded, color="primary", @click="validateWithInfo().then(submit)") GET QUOTATION
</template>
<script>
import { TYPE_SERVICE_STATUS } from "@/helpers/DefaultValue";
import { DEFAULT_MSBOOKING_VALUE } from "@/helpers/public/DefaultValue";
import ValidateMixins from "@/mixins/ValidateMixins.vue";
import {
  GetFormattedDateOnlyString,
  GetFormattedTimeOnlyString,
  GetFormattedLocaleDateOnlyString,
  GetLocaleISODateOnlyObject
} from "@/helpers/Date";
import { mapState, mapMutations, mapGetters } from "vuex";
import { WEBURL_PUBLIC } from "@/helpers/Url";
import axios from "@/plugins/axios";
export default {
  name: "TheMsForm",
  components: {
    TheLogin: () => import(/* webpackChunkName: "cmp.publicview.tlogin" */ "@/components/publicview/TheLogin")
  },
  mixins: [ValidateMixins],
  data: () => ({
    allowed_hour: [
      { text: "10 AM", value: "10:00:00" },
      { text: "2 PM", value: "14:00:00" }
    ],
    allowed_day: [],
    holder: {
      date_menu: false,
      dialog_login: false,
      dialog: false,
      selected_type: null
    },
    listing: {
      types_headers: [
        { text: "name", align: "start", value: "name" },
        { text: "Actions", align: "end", value: "actions" }
      ],
      types: []
    },
    item: DEFAULT_MSBOOKING_VALUE,
    isBusy: false,
    TYPE_SERVICE_STATUS,
    offday: []
  }),
  computed: {
    ...mapGetters("setting", ["isLogin", "isCustomer"]),
    ...mapState("setting", ["Setting", "Currency", "UserInfo", "TermAndConditionUrl"]),
    ...mapState({ MSObject: "MS" }),
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isLoginCustomer() {
      return this.isLogin && this.isCustomer;
    },
    minBookDate() {
      var date = new Date();
      // default today date
      if (this.Setting && this.Setting.min_book_day > 0) {
        date.setDate(date.getDate() + this.Setting.min_book_day);
      }
      return GetLocaleISODateOnlyObject(date);
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    GetFormattedLocaleDateOnlyString,
    GetFormattedDateOnlyString,
    GetFormattedTimeOnlyString,
    ...mapMutations({ setMSObject: "setMS" }),
    ...mapMutations("spinner", ["setSpinnerLoading"]),
    initialize() {
      axios.get(WEBURL_PUBLIC.getOffDays).then(res => {
        let data = res.data;
        if (data.length > 0) {
          this.offday = data;
        }
      });
      this.allowed_day = this.Setting.days;
      this.item = Object.assign({}, this.item, this.MSObject);
      this.assignContactInfo();
      this.getTypes();
    },
    assignContactInfo() {
      let item = this.item;
      let loginUserInfo = this.UserInfo;
      if (loginUserInfo) {
        item.company_name = loginUserInfo.companyname;
        item.first_name = loginUserInfo.firstname;
        item.last_name = loginUserInfo.lastname;
        item.contact = loginUserInfo.contact;
        item.contact_other = loginUserInfo.contact2;
        item.email = loginUserInfo.email;

        // check if address exist
        if (loginUserInfo.address) {
          let address = loginUserInfo.address;
          if (address && address.length > 0) {
            // currently pick first address by default
            item.address = address[0].address;
          }
        }
      }
      // trigger reactive
      this.item = Object.assign({}, this.item, item);
    },
    getTypes() {
      if (this.isBusy) return;
      this.isBusy = true;
      this.setSpinnerLoading(true);

      let param = {
        // only for get method
        params: {
          obj_id: TYPE_SERVICE_STATUS.MS.ID
        }
      };

      axios
        .get(WEBURL_PUBLIC.getServiceType, param)
        .then(res => {
          let data = res.data;
          if (data.items && data.items.length > 0) {
            this.listing.types = data.items.map((item, index) => ({
              idx: index,
              selected: false,
              ...item
            }));
          }
          this.isBusy = false;
          this.setSpinnerLoading(false);
        })
        .catch(() => {
          this.isBusy = false;
          this.setSpinnerLoading(false);
        });
    },
    submit(resp) {
      if (resp.isValid) {
        // check service type first if empty
        if (this.item.types.length > 0) {
          return this.next();
        }

        return this.$eventHub.$emit("on-show-snackbar", {
          message: "Please select at least one service type.",
          color: "error",
          position: {
            top: true
          },
          timeout: 10000
        });
      }
      let errors = resp.errors;
      if (errors) {
        for (const key in errors) {
          if (errors[key].length > 0) {
            this.$eventHub.$emit("on-show-snackbar", {
              message: JSON.stringify(errors[key][0]),
              color: "error",
              position: {
                top: true
              },
              timeout: 10000
            });
            break;
          }
        }
        this.onErrorFocus("observer");
      }
    },
    next() {
      this.saveQuotation();
    },
    saveQuotation() {
      if (this.isBusy) return;
      this.isBusy = true;
      this.setSpinnerLoading(true);

      let param = {
        items: Object.assign({}, this.item),
        type: TYPE_SERVICE_STATUS.MS.ID
      };

      axios
        .post(WEBURL_PUBLIC.saveQuotation, param)
        .then(res => {
          if (res.data) {
            let data = JSON.parse(res.data.d);
            if (data) {
              this.$eventHub.$emit("on-show-snackbar", {
                message: data.message,
                color: data.status ? "blue" : "error",
                timeout: -1,
                position: {
                  top: true
                }
              });

              // only proceed if success
              if (data.status) {
                this.isBusy = false;
                this.setSpinnerLoading(false);
                this.goHomePage();
              }
            }
          }
          this.isBusy = false;
          this.setSpinnerLoading(false);
        })
        .catch(() => {
          this.isBusy = false;
          this.setSpinnerLoading(false);
        });
    },
    goHomePage() {
      // Clear Booking Detail Before go to homepage (prepare for new booking)
      this.setMSObject(DEFAULT_MSBOOKING_VALUE);
      this.$emit("update", { type: TYPE_SERVICE_STATUS.UNKNOWN.ID });
    },
    checkAllowedDay(v) {
      let d = new Date(v);
      if (d) {
        if (this.offday && this.offday.length > 0) {
          for (var i = 0; i < this.offday.length; i++) {
            if (
              GetFormattedLocaleDateOnlyString(d) >= GetFormattedLocaleDateOnlyString(this.offday[i].date_from) &&
              GetFormattedLocaleDateOnlyString(d) <= GetFormattedLocaleDateOnlyString(this.offday[i].date_to)
            ) {
              return false;
            }
          }
        }
        return this.allowed_day.indexOf(d.getDay()) >= 0;
      }
      return false;
    },
    onSignIn() {
      this.holder.dialog_login = true;
    },
    onSignInSuccess() {
      this.holder.dialog_login = false;
      this.assignContactInfo();
    },
    onServiceTypeClick() {
      // clear type before add new
      this.item.types = [];
      this.$nextTick(() => {
        this.item.types = this.listing.types.filter(x => x.selected).map(v => v.id);
      });
    },
    showInfo(item) {
      this.holder.selected_type = item;
      this.holder.dialog = true;
      // hide main form close button
      var elem = parent.document.getElementById("TB_closeAjaxWindow");
      if (elem) {
        elem.style.display = "none";
      }
    },
    closeInfo() {
      this.holder.selected_type = null;
      this.holder.dialog = false;
      // show main form close button
      var elem = parent.document.getElementById("TB_closeAjaxWindow");
      if (elem) {
        elem.style.display = "";
      }
    },
    openFiles() {
      var filePath = "/data/custom/quotations/" + this.holder.selected_type.id + "/" + this.holder.selected_type.files;
      window.open(filePath, "_blank");
    },
    openTermAndCondition() {
      window.open(this.TermAndConditionUrl, "_blank");
    }
  }
};
</script>
<style lang="scss">
.the-ms-form {
  .main-title {
    font-weight: 700;
    font-size: 22px;
  }
  .info-text,
  .info-text label {
    font-size: 14px;
  }
  .signin-btn {
    font-weight: 600;
    display: inline-block;
    cursor: pointer;
  }
  .reminder-checkbox {
    i,
    label {
      color: #1572b6;
    }
  }
  .info-textarea-text {
    font-size: 12px;
    font-weight: 500;
  }
  input:disabled,
  textarea:disabled {
    color: rgba(100, 95, 95, 0.8);
  }
  hr {
    background: #1572b6;
    border-top: 1px solid;
  }
  .transparent-input {
    input,
    textarea,
    i,
    .v-text-field__prefix {
      color: #1572b6;
    }
    > .v-input__control > .v-input__slot {
      background: rgba(255, 255, 255, 0);
    }
  }
  .input-right-align {
    input {
      text-align: right;
    }
  }
  .inline-block {
    display: inline-block;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .header-info {
    display: flex;
    justify-content: space-between;
  }
}
</style>
